import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../index';
import { IUser } from 'store/slices/authStore/authSlice';
import { IPost } from './postManagementService';
import { IBase } from 'models';
const { REACT_APP_API_URL } = process.env;

interface ISellerReviews {
  id: number;
  seller_id: number;
  user_id: number;
  post_id: number;
  comment: string;
  created_at: Date;
  refund_process: number;
  description_accuracy: number;
  communicability: number;
  shipping_speed: number;
  rating: string;
  post: IPost;
  user: IUser;
}

export interface ISeller extends IUser {
  review_count: number;
}

export const sellerApi = createApi({
  reducerPath: 'sellerService',
  tagTypes: ['Seller'],
  baseQuery: fetchBaseQuery({
    baseUrl: REACT_APP_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;
      const token = state.auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getSellerInfo: builder.query<ISeller, number>({
      query: (sellerId) => ({
        url: `/api/seller-info/${sellerId}`,
        method: 'GET',
      }),
      providesTags: ['Seller'],
    }),
    getSellerReview: builder.query<IBase<ISellerReviews>, number>({
      query: (sellerId) => ({
        url: `/api/seller-reviews/${sellerId}`,
        method: 'GET',
      }),
      providesTags: ['Seller'],
    }),
  }),
});

export const { useGetSellerInfoQuery, useGetSellerReviewQuery } = sellerApi;
